import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/layout/Layout';
import { Home } from '@/pages/Home';
import { About } from '@/pages/About';
import { Courses } from '@/pages/Courses';
import { FacultyDetail } from '@/pages/FacultyDetail';
import { Examinations } from '@/pages/Examinations';
import { Affiliation } from '@/pages/Affiliation';
import { Centres } from '@/pages/Centres';
import { Notices } from '@/pages/Notices';
import { EJournal } from '@/pages/EJournal';
import { Events } from '@/pages/Events';
import { Contact } from '@/pages/Contact';
import { NotFound } from '@/pages/NotFound';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="courses" element={<Courses />} />
          <Route path="courses/:slug" element={<FacultyDetail />} />
          <Route path="examinations" element={<Examinations />} />
          <Route path="affiliation" element={<Affiliation />} />
          <Route path="centres" element={<Centres key="institutes" />} />
          <Route path="centres/practical" element={<Centres key="practical" practical />} />
          <Route path="notices" element={<Notices />} />
          <Route path="e-journal" element={<EJournal />} />
          {/* The old name of this page. */}
          <Route path="bulletins" element={<Navigate to="/e-journal" replace />} />
          <Route path="events" element={<Events />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
